<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-3 d-print-none d-flex align-items-center">
          <span class="toolbar-title">RSSWA Forms</span>
        </div>
        <div
          class="col-12 col-md-3 d-flex flex-column align-items-start justify-content-center"
        >
          <h1
            [ngClass]="rsswa?.formStatus?.color"
            id="serialNumber"
            [matTooltip]="rsswa?.wfTable?.name ?? ''"
          >
            {{ rsswa?.serialNo }}
          </h1>
          <span
            *ngIf="rsswa"
            class="status"
            [ngClass]="rsswa.formStatus?.color"
          >
            {{ rsswa.formStatus?.name }}
          </span>
        </div>
        <div class="col-12 col-md-2 d-flex align-items-center type-header">
          <mat-form-field
            appearance="outline"
            *ngIf="rsswa"
            class="no-subscript"
          >
            <mat-label>Initiated by</mat-label>
            <input
              aria-label="operator"
              matInput
              type="text"
              [(ngModel)]="rsswa.createdByName"
              disabled
            />
          </mat-form-field>
        </div>
        <div class="col-12 col-md-2 d-flex align-items-center type-header">
          <mat-form-field
            appearance="outline"
            *ngIf="rsswa"
            class="no-subscript"
          >
            <mat-label>Created Date</mat-label>
            <input
              matInput
              class="dateInput"
              placeholder="Date"
              disabled
              datetime="MM-dd-yyyy"
              [value]="formatDate(rsswa.createdOn)"
            />
          </mat-form-field>
        </div>
        <div
          class="col-12 col-md-2 d-flex flex-column justify-content-center align-items-end"
        >
          <div class="d-flex small" *ngIf="showAmendmentToggle">
            <mat-slide-toggle
              class="float-right d-print-none"
              *ngIf="
                hasPrivilege(privilegeEnum.ViewRSSWAAmendment) ||
                hasPrivilege(privilegeEnum.EditRSSWAAmendment) ||
                service.isRequester(rsswa)
              "
              (change)="showAmendmentChange($event)"
              name="amendment"
              [ngModel]="status.isViewingAmendment"
              >Show Pending Amendment
            </mat-slide-toggle>
          </div>
          <div class="d-flex small d-print-none" *ngIf="rsswa?.editingBy">
            Modifying by:&nbsp;<b class="yellow">{{
              rsswa?.editingBy?.name
            }}</b>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item class="show-overflow">
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
          <mat-hint align="start"
            >Use <span style="color: red">-term</span> to exclude
            results</mat-hint
          >
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <rsswa-side-panel
              [filter]="filter"
              (rowSelected)="rowSelected($event)"
            ></rsswa-side-panel>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="hasPrivilege(privilegeEnum.RSSWA)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="edit(true)"
          class="parent"
          *ngIf="
            (rsswa?.status == formStatusEnum.Draft ||
              rsswa?.status == formStatusEnum.New) &&
            hasPrivilege(privilegeEnum.RSSWA) &&
            !rsswa?.editingBy
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Modify Form</span
          >
          <mat-icon matListItemIcon class="yellow">edit</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="requestAmendment()"
          class="parent"
          *ngIf="
            rsswa &&
            rsswa.status === formStatusEnum.Active &&
            canCreateAmendment &&
            !testingCompleteSigned
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create Amendment</span
          >
          <mat-icon matListItemIcon class="red">healing</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="edit(true)"
          class="parent"
          *ngIf="
            rsswa?.status == formStatusEnum.AmendmentDrafting &&
            hasPrivilege(privilegeEnum.EditRSSWAAmendment) &&
            !rsswa?.editingBy
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Modify Amendment</span
          >
          <mat-icon matListItemIcon class="yellow">edit</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="duplicate()"
          class="parent"
          *ngIf="
            rsswa &&
            hasPrivilege(privilegeEnum.RSSWA) &&
            rsswa.status !== formStatusEnum.New
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Copy Form</span
          >
          <mat-icon matListItemIcon class="blue">content_copy</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="edit(false)"
          class="parent"
          *ngIf="canReleaseEditingForm()"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Release Form</span
          >
          <mat-icon matListItemIcon class="red">lock_open</mat-icon>
        </mat-list-item>

        <form-history-button
          #showHistory
          [hidden]="!rsswa"
          [isExpanded]="isExpanded"
          [isShowing]="isShowing"
        ></form-history-button>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div
          class="sidenav-content"
          [ngClass]="{
            amendment: status.isViewingAmendment
          }"
        >
          <rsswa-main-panel
            #mainPanel
            *ngIf="!showHistory.value"
            id="mainPanel"
            [rsswa]="rsswa"
            [status]="status"
            [testingCompleteSigned]="testingCompleteSigned"
            (changed)="rsswa = $event"
          ></rsswa-main-panel>
          <form-history
            [form]="rsswa"
            class="mt-2"
            *ngIf="showHistory.value && rsswa"
          ></form-history>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
